export class Comparers {
  public static defaultComparer(object1: any, object2: any): boolean {
    return object1 && object2 && object1.id === object2.id;
  }
}
